module.exports = __webpack_public_path__ + "img/triangle-middle_hover.a420a56a.png";